import type { CurrentTenant, ShallowClient, Client } from 'niara-spear-crudmodel/src';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export interface CoreState {
  // client usado apenas quando o client é fixo (ex: otabuilder, quotation, logado como selfbooking) - não mudar este campo se for algo temporário (ex: critério de busca)
  client?: ShallowClient & Partial<Client>;
  clientId?: string;
  tenant?: CurrentTenant;
  tenantId?: string;
  /**
   * @deprecated Usar history.createHref({ pathname: generatePath('/engineRules/:id', { id: engineRuleId }) })
   */
  basePath?: string;
}
const coreSlice = createSlice({
  name: 'core',
  initialState: {} as CoreState,
  reducers: {
    updateState: (state, action: PayloadAction<Partial<CoreState>>) => {
      const tenant = action.payload.tenant;
      const client = action.payload.client;
      const clientId = client ? client.id : action.payload.clientId ?? state.clientId;
      const tenantId = tenant ? tenant.tenantId : action.payload.tenantId ?? state.tenantId;
      return {
        ...state,
        ...action.payload,
        clientId,
        tenantId
      };
    },
    setBasePath: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        basePath: action.payload
      };
    }
  }
});
export const {
  updateState,
  /** @deprecated */setBasePath
} = coreSlice.actions;

/**
 * Renomeei setState para updateState, pois setState dá a impressão que a
 * atualização será de todo o state. No caso, só atualiza com os campos passados
 * ao updateState.
 * @deprecated
 */
export const setState = updateState;
export default coreSlice.reducer;